import React from "react";
import CourseList from "./CourseList";
import EmptyCourses from "./EmptyCourses";
import { Spinner } from "../library";

export default function CoursesData(props) {
  const { loading, courseCategories, justOwned, justNotOwned, emptyMessage, emptyDescription, emptyIcon, emptyLinkTo, emptyLinkText } = props;
  const isEmpty = !courseCategories || courseCategories.length === 0;

  if (loading) return <Spinner wrapped />;

  if (isEmpty) {
    return (
      <EmptyCourses
        message={emptyMessage}
        description={emptyDescription}
        icon={emptyIcon}
        linkTo={emptyLinkTo}
        linkText={emptyLinkText}
      />
    );
  }

  return (
    <CourseList
      courseCategories={courseCategories}
      justNotOwned={justNotOwned}
      justOwned={justOwned}
    />
  );
}
